import React, { useEffect, useState } from 'react';

import { Typography } from "@material-ui/core";

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from "@material-ui/core/styles";

import PolicyReviewCard from './Components/PolicyReviewCard';
import { getUnreadPolicies } from '../../db/policies';
import { getCompanyRemoteData } from '../../db/index';

const useStyles = makeStyles((theme) => ({
    container: {
      height: "calc(100vh - 180px)",
      maxHeight: "calc(100vh - 100px)",
      width: "calc(100% - 300px)",
      display: "flex",
      flexDirection: "column",
      overflow: "auto",
      margin: "auto",
      padding: "30px"
    },
    content: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
    },
    companyContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: "20px 0",
        padding: "10px 0"
    },
    progressContainer: {
        width: "100%",
        height: "400px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
}));

export default function Policies() {
    const [unreadPolicies, setUnreadPolicies] = React.useState([])
    const [loading, setLoading] = React.useState(true);
    const [numLoads, setNumLoads] = React.useState(0);
    
    const classes = useStyles();

    useEffect(() => {
        async function fetchData() {
            let policies = await getUnreadPolicies();

            // see if there are current policies for the companies in this list 
            let enhancedPolicies = policies.map(async (company) => {
                const companyName = company.submissions[0].companyName;
                let currentData = await getCompanyRemoteData(companyName);

                if (currentData) {
                    company.data = currentData;
                }
                return company;
            })

            // console.log('policies: ', policies);
            const completeData = await Promise.all(enhancedPolicies);
            setUnreadPolicies(completeData);
            setLoading(false);
        }
        setLoading(true);
        fetchData();
    }, [numLoads])

    const triggerRefresh = () => { 
        setNumLoads(numLoads + 1);
    }

    const renderPolicies = () => {
        if (loading) {
            return (
                <div className={classes.progressContainer}>
                    <CircularProgress />
                </div>
            )
        }

        return unreadPolicies.map(policy => {
            return (
                <div className={classes.companyContainer}>
                    {policy.submissions.map(sub => {
                        return <PolicyReviewCard policy={policy} triggerRefresh={triggerRefresh} />
                    })}
                </div>
            )
        })
    }

    return (
        <div className={classes.container}>
            <Typography variant="h5" className={classes.detailText} align="center">
                {`Newly Submitted Policies: ${unreadPolicies.length} unread`}
            </Typography>
            <div className={classes.content}>
                {renderPolicies()}
            </div>
        </div>
    )
}